module.exports = require("./kln.d.ts");